import type { CollaboratorSummary } from '../../services/tasks/taskCollaborationService';
import { Avatar } from '../ui/Avatar';
import { CollaboratorLink } from '../collaborators/CollaboratorLink';

interface AssigneeLabelProps {
  assignees: CollaboratorSummary[];
  size?: 'xs' | 'sm';
}

/**
 * Avatar + nom du premier assigné (le "responsable de traitement"), avec un
 * suffixe "+N" si la tâche compte plusieurs assignés. Le nom et l'avatar
 * pointent vers le profil du collaborateur.
 */
export function AssigneeLabel({ assignees, size = 'xs' }: AssigneeLabelProps) {
  if (assignees.length === 0) return null;
  const [first, ...rest] = assignees;
  if (!first) return null;

  return (
    <span className="inline-flex items-center gap-1.5 min-w-0">
      <CollaboratorLink
        collaboratorId={first.id}
        title={first.full_name}
        className="inline-flex items-center gap-1.5 min-w-0 rounded hover:underline"
      >
        <Avatar name={first.full_name} src={first.avatar_url} size={size} />
        <span className="text-xs text-cime-text-muted truncate max-w-[10rem]">
          {first.full_name}
        </span>
      </CollaboratorLink>
      {rest.length > 0 && (
        <span
          className="text-[10px] font-semibold text-neutral-500"
          title={rest.map((c) => c.full_name).join(', ')}
        >
          +{rest.length}
        </span>
      )}
    </span>
  );
}
